import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import WebSocketService from '../../services/WebSocketService';

const WebSocketProvider = ({ children }) => {
  const { isLoggedIn, user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user && user.id) {
      WebSocketService.connect(user.id);
      return;
    }
    WebSocketService.disconnect();
  }, [user?.id]); // Depende apenas do ID — evita reconexão quando o objeto user é recriado pelo Redux com mesmos dados

  return children;
};

export default WebSocketProvider;
